
import { Link, useNavigate } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const navigate = useNavigate();

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      {/* Contact Info Bar */}
      <div className="bg-blue-600 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center text-xs md:text-sm">
            <div className="flex items-center space-x-4 mb-1 sm:mb-0">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line"></i>
                <span>+1-943-238-3483</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line"></i>
                <span>ameethed@gmail.com</span>
              </div>
            </div>
            <div className="text-xs">
              Making a difference worldwide
            </div>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 md:h-16">
          <div className="flex items-center space-x-4">
            <img 
              src="https://static.readdy.ai/image/d9bb5601c98f22586a2b11870925187d/d373630d6537f2b05ea3760230c302e1.jfif"
              alt="Bible Believers Tabernacle"
              className="h-8 md:h-12 w-auto"
            />
            <nav className="flex space-x-3 sm:space-x-6 md:space-x-8 ml-2 md:ml-8">
              <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer text-sm md:text-base">
                Home
              </Link>
              <Link to="/projects" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer text-sm md:text-base">
                Projects
              </Link>
              <Link to="/about" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer text-sm md:text-base">
                About
              </Link>
            </nav>
          </div>
          <div className="flex items-center">
            <Button 
              variant="outline" 
              size="sm"
              onClick={() => navigate('/donate')}
              className="text-xs md:text-sm px-2 md:px-4 py-2"
            >
              Donate
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
